import { fetchApi } from '@/services/api-client';
import type { components } from '@/services/openapi';

export const HOUSES_PATH = '/admin/houses';

export type House = {
  id: string;
  name: string;
  color: string | null;
  sortOrder: number;
  active: boolean;
  createdAt: string;
  updatedAt: string;
};

export type RosterPerson = components['schemas']['RosterPersonResponse'];
export type HouseRosterColumn = components['schemas']['HouseRosterColumnResponse'];
export type HouseRoster = components['schemas']['HouseRosterResponse'];
export type UserHouse = components['schemas']['UserHouseResponse'];

export const housesApi = {
  roster: () => fetchApi<HouseRoster>(`${HOUSES_PATH}/roster`),
  setStaffHouse: (userId: string, houseId: string | null) =>
    fetchApi<UserHouse>(`${HOUSES_PATH}/staff/${userId}`, { method: 'PUT', body: JSON.stringify({ houseId }) }),
  setStudentHouse: (studentId: string, houseId: string | null) =>
    fetchApi<UserHouse>(`${HOUSES_PATH}/students/${studentId}`, { method: 'PUT', body: JSON.stringify({ houseId }) }),
  list: () => fetchApi<House[]>(HOUSES_PATH),
  getById: (id: string) => fetchApi<House>(`${HOUSES_PATH}/${id}`),
  create: (data: { name: string; color?: string; sortOrder?: number; active?: boolean }) =>
    fetchApi<House>(HOUSES_PATH, { method: 'POST', body: JSON.stringify(data) }),
  update: (id: string, data: { name?: string; color?: string | null; sortOrder?: number; active?: boolean }) =>
    fetchApi<House>(`${HOUSES_PATH}/${id}`, { method: 'PATCH', body: JSON.stringify(data) }),
  delete: (id: string) => fetchApi<{ success: boolean }>(`${HOUSES_PATH}/${id}`, { method: 'DELETE' }),
};
